webpackJsonp([13994203391546835000],{

/***/ "./src/components/CtaButton.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  border: 1px solid ', ';\n  border-radius: 3px;\n  padding: 25px;\n  font-size: 2rem;\n  color: ', ';\n  display: inline-block;\n  transition: all .3s ease;\n  \n  &:hover {\n    color: white;\n    background: ', ';\n  }\n'], ['\n  border: 1px solid ', ';\n  border-radius: 3px;\n  padding: 25px;\n  font-size: 2rem;\n  color: ', ';\n  display: inline-block;\n  transition: all .3s ease;\n  \n  &:hover {\n    color: white;\n    background: ', ';\n  }\n']);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ctaButton = function (_Component) {
	  _inherits(ctaButton, _Component);
	
	  function ctaButton() {
	    _classCallCheck(this, ctaButton);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ctaButton.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      { style: { border: 'none' }, to: this.props.to },
	      _react2.default.createElement(
	        ButtonContainer,
	        null,
	        children
	      )
	    );
	  };
	
	  return ctaButton;
	}(_react.Component);
	
	exports.default = ctaButton;
	
	
	var ButtonContainer = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.brand;
	}, function (props) {
	  return props.theme.brand;
	}, function (props) {
	  return props.theme.brand;
	});
	module.exports = exports['default'];

/***/ }),

/***/ "./src/pages/data.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/data.de3dd418.jpg";

/***/ }),

/***/ "./src/pages/guides.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/guides.b60bb963.jpg";

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-lodash/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  padding: ", ";\n  text-align: center;\n"], ["\n  background: ", ";\n  padding: ", ";\n  text-align: center;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  padding: 20px 0;\n  & > h1 {\n    font-weight: 400;\n  }\n"], ["\n  padding: 20px 0;\n  & > h1 {\n    font-weight: 400;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  padding: ", ";\n  max-width: ", ";\n  margin: 0 auto;\n\n  *{\n    margin: 0;\n    padding: 0;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n  }\n\n  h1{\n    font-size: 2.5rem;\n    font-family: 'Montserrat';\n    font-weight: normal;\n    color: #444;\n    text-align: center;\n    margin: 2rem 0;\n  }\n\n  .wrapper{\n    width: 90%;\n    margin: 0 auto;\n    max-width: 80rem;\n  }\n\n  .cols{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n  }\n\n  .col{\n    width: calc(25% - 2rem);\n    margin: 1rem;\n    cursor: pointer;\n  }\n\n  .container{\n    -webkit-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n  \t-webkit-perspective: 1000px;\n  \t        perspective: 1000px;\n  }\n\n  .front,\n  .back{\n    background-size: cover;\n  \tbackground-position: center;\n  \t-webkit-transition: -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n  \ttransition: -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n  \t-o-transition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n  \ttransition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n  \ttransition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1), -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n  \t-webkit-backface-visibility: hidden;\n  \t        backface-visibility: hidden;\n  \ttext-align: center;\n  \tmin-height: 280px;\n  \theight: auto;\n  \tborder-radius: 10px;\n  \tcolor: #fff;\n  \tfont-size: 1.5rem;\n  }\n\n  .back{\n    ", "\n    background: #55786C;\n    background: -webkit-linear-gradient(45deg,  #55786C 0%,#596a72 100%);\n    background: -o-linear-gradient(45deg,  #55786C 0%,#596a72 100%);\n    background: linear-gradient(45deg,  #55786C 0%,#596a72 100%);\n  }\n\n  .front:after{\n  \tposition: absolute;\n      top: 0;\n      left: 0;\n      z-index: 1;\n      width: 100%;\n      height: 100%;\n      content: '';\n      display: block;\n      opacity: .4;\n      background-color: #000;\n      -webkit-backface-visibility: hidden;\n              backface-visibility: hidden;\n      border-radius: 10px;\n  }\n  .container:hover .front,\n  .container:hover .back{\n      -webkit-transition: -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n      transition: -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n      -o-transition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n      transition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n      transition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1), -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n  }\n\n  .back{\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n  }\n\n  .inner{\n      -webkit-transform: translateY(-50%) translateZ(60px) scale(0.94);\n              transform: translateY(-50%) translateZ(60px) scale(0.94);\n      top: 50%;\n      position: absolute;\n      left: 0;\n      width: 100%;\n      padding: 2rem;\n      -webkit-box-sizing: border-box;\n              box-sizing: border-box;\n      outline: 1px solid transparent;\n      -webkit-perspective: inherit;\n              perspective: inherit;\n      z-index: 2;\n  }\n\n  .container .back{\n      -webkit-transform: rotateY(180deg);\n              transform: rotateY(180deg);\n      -webkit-transform-style: preserve-3d;\n              transform-style: preserve-3d;\n  }\n\n  .container .front{\n      -webkit-transform: rotateY(0deg);\n              transform: rotateY(0deg);\n      -webkit-transform-style: preserve-3d;\n              transform-style: preserve-3d;\n  }\n\n  .container:hover .back{\n    -webkit-transform: rotateY(0deg);\n            transform: rotateY(0deg);\n    -webkit-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n  }\n\n  .container:hover .front{\n    -webkit-transform: rotateY(-180deg);\n            transform: rotateY(-180deg);\n    -webkit-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n  }\n\n  .front .inner p{\n    font-size: 3rem;\n    margin-bottom: 2rem;\n    position: relative;\n  }\n\n  .front .inner p:after{\n    content: '';\n    width: 4rem;\n    height: 2px;\n    position: absolute;\n    background: #C6D4DF;\n    display: block;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    bottom: -.75rem;\n  }\n\n  .front .inner span{\n    color: rgba(255,255,255,0.7);\n    font-family: 'Montserrat';\n    font-weight: 300;\n    font-size: 2rem;\n  }\n\n  @media screen and (max-width: 164rem){\n    .col{\n      width: calc(33.333333% - 2rem);\n    }\n  }\n\n  @media screen and (max-width: 48rem){\n    .col{\n      width: calc(50% - 2rem);\n    }\n  }\n\n  @media screen and (max-width: 32rem){\n    .col{\n      width: 100%;\n      margin: 0 0 2rem 0;\n    }\n  }\n\n"], ["\n  padding: ", ";\n  max-width: ", ";\n  margin: 0 auto;\n\n  *{\n    margin: 0;\n    padding: 0;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n  }\n\n  h1{\n    font-size: 2.5rem;\n    font-family: 'Montserrat';\n    font-weight: normal;\n    color: #444;\n    text-align: center;\n    margin: 2rem 0;\n  }\n\n  .wrapper{\n    width: 90%;\n    margin: 0 auto;\n    max-width: 80rem;\n  }\n\n  .cols{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n  }\n\n  .col{\n    width: calc(25% - 2rem);\n    margin: 1rem;\n    cursor: pointer;\n  }\n\n  .container{\n    -webkit-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n  \t-webkit-perspective: 1000px;\n  \t        perspective: 1000px;\n  }\n\n  .front,\n  .back{\n    background-size: cover;\n  \tbackground-position: center;\n  \t-webkit-transition: -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n  \ttransition: -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n  \t-o-transition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n  \ttransition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n  \ttransition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1), -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n  \t-webkit-backface-visibility: hidden;\n  \t        backface-visibility: hidden;\n  \ttext-align: center;\n  \tmin-height: 280px;\n  \theight: auto;\n  \tborder-radius: 10px;\n  \tcolor: #fff;\n  \tfont-size: 1.5rem;\n  }\n\n  .back{\n    ", "\n    background: #55786C;\n    background: -webkit-linear-gradient(45deg,  #55786C 0%,#596a72 100%);\n    background: -o-linear-gradient(45deg,  #55786C 0%,#596a72 100%);\n    background: linear-gradient(45deg,  #55786C 0%,#596a72 100%);\n  }\n\n  .front:after{\n  \tposition: absolute;\n      top: 0;\n      left: 0;\n      z-index: 1;\n      width: 100%;\n      height: 100%;\n      content: '';\n      display: block;\n      opacity: .4;\n      background-color: #000;\n      -webkit-backface-visibility: hidden;\n              backface-visibility: hidden;\n      border-radius: 10px;\n  }\n  .container:hover .front,\n  .container:hover .back{\n      -webkit-transition: -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n      transition: -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n      -o-transition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n      transition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n      transition: transform .7s cubic-bezier(0.4, 0.2, 0.2, 1), -webkit-transform .7s cubic-bezier(0.4, 0.2, 0.2, 1);\n  }\n\n  .back{\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n  }\n\n  .inner{\n      -webkit-transform: translateY(-50%) translateZ(60px) scale(0.94);\n              transform: translateY(-50%) translateZ(60px) scale(0.94);\n      top: 50%;\n      position: absolute;\n      left: 0;\n      width: 100%;\n      padding: 2rem;\n      -webkit-box-sizing: border-box;\n              box-sizing: border-box;\n      outline: 1px solid transparent;\n      -webkit-perspective: inherit;\n              perspective: inherit;\n      z-index: 2;\n  }\n\n  .container .back{\n      -webkit-transform: rotateY(180deg);\n              transform: rotateY(180deg);\n      -webkit-transform-style: preserve-3d;\n              transform-style: preserve-3d;\n  }\n\n  .container .front{\n      -webkit-transform: rotateY(0deg);\n              transform: rotateY(0deg);\n      -webkit-transform-style: preserve-3d;\n              transform-style: preserve-3d;\n  }\n\n  .container:hover .back{\n    -webkit-transform: rotateY(0deg);\n            transform: rotateY(0deg);\n    -webkit-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n  }\n\n  .container:hover .front{\n    -webkit-transform: rotateY(-180deg);\n            transform: rotateY(-180deg);\n    -webkit-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n  }\n\n  .front .inner p{\n    font-size: 3rem;\n    margin-bottom: 2rem;\n    position: relative;\n  }\n\n  .front .inner p:after{\n    content: '';\n    width: 4rem;\n    height: 2px;\n    position: absolute;\n    background: #C6D4DF;\n    display: block;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    bottom: -.75rem;\n  }\n\n  .front .inner span{\n    color: rgba(255,255,255,0.7);\n    font-family: 'Montserrat';\n    font-weight: 300;\n    font-size: 2rem;\n  }\n\n  @media screen and (max-width: 164rem){\n    .col{\n      width: calc(33.333333% - 2rem);\n    }\n  }\n\n  @media screen and (max-width: 48rem){\n    .col{\n      width: calc(50% - 2rem);\n    }\n  }\n\n  @media screen and (max-width: 32rem){\n    .col{\n      width: 100%;\n      margin: 0 0 2rem 0;\n    }\n  }\n\n"]);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _SEO = __webpack_require__("./src/components/SEO/SEO.jsx");
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _SiteConfig = __webpack_require__("./data/SiteConfig.js");
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _CtaButton = __webpack_require__("./src/components/CtaButton.jsx");
	
	var _CtaButton2 = _interopRequireDefault(_CtaButton);
	
	var _Navigation = __webpack_require__("./src/components/Layout/Navigation.jsx");
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _guides = __webpack_require__("./src/pages/guides.jpg");
	
	var _guides2 = _interopRequireDefault(_guides);
	
	var _data = __webpack_require__("./src/pages/data.jpg");
	
	var _data2 = _interopRequireDefault(_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import "../layouts/css/react-data-grid.css";
	// import "./css/cards.css";
	
	var Index = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index() {
	    _classCallCheck(this, Index);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Index.prototype.render = function render() {
	    var postEdges = this.props.data.allMarkdownRemark.edges;
	    return _react2.default.createElement(
	      "div",
	      { className: "index-container" },
	      _react2.default.createElement(_reactHelmet2.default, { title: _SiteConfig2.default.siteTitle }),
	      _react2.default.createElement(_SEO2.default, { postEdges: postEdges }),
	      _react2.default.createElement(
	        "main",
	        null,
	        _react2.default.createElement(
	          IndexHeadContainer,
	          null,
	          _react2.default.createElement(_Navigation2.default, null),
	          _react2.default.createElement(
	            Hero,
	            { style: { color: "white" } },
	            _react2.default.createElement("img", { src: _SiteConfig2.default.siteLogo, width: "150px" }),
	            _react2.default.createElement(
	              "h1",
	              null,
	              _SiteConfig2.default.siteTitle
	            ),
	            _react2.default.createElement(
	              "h4",
	              null,
	              _SiteConfig2.default.siteDescription
	            )
	          )
	        ),
	        _react2.default.createElement(
	          BodyContainer,
	          null,
	          _react2.default.createElement(
	            "div",
	            { className: "wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "cols" },
	              _react2.default.createElement(
	                "div",
	                { className: "col", ontouchstart: "this.classList.toggle('hover');" },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  {
	                    style: { boxShadow: 'none' },
	                    css: { color: 'inherit' },
	                    to: "/guides" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "container" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "front", style: { backgroundImage: "url(" + _guides2.default + ")" } },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "inner" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Guides"
	                        ),
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Online guides"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "back" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "inner" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Collection of GECHO technical guides"
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col", ontouchstart: "this.classList.toggle('hover');" },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  {
	                    style: { boxShadow: 'none' },
	                    css: { color: 'inherit' },
	                    to: "/data" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "container" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "front", style: { backgroundImage: "url(" + _data2.default + ")" } },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "inner" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Data"
	                        ),
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Data and map collections"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "back" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "inner" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          "Collection of relevant online datasets"
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Index;
	}(_react2.default.Component);
	
	exports.default = Index;
	
	
	var IndexHeadContainer = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.brand;
	}, function (props) {
	  return props.theme.sitePadding;
	});
	
	var Hero = _styledComponents2.default.div(_templateObject2);
	
	var BodyContainer = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.theme.sitePadding;
	}, function (props) {
	  return props.theme.contentWidthLaptop;
	}, '' /* background: #cedce7; */);
	
	/* eslint no-undef: "off"*/
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-586c6f037700073dc82f.js